import { render } from "./FormCurrentInsulationView.vue?vue&type=template&id=522bde4c"
import script from "./FormCurrentInsulationView.vue?vue&type=script&lang=js"
export * from "./FormCurrentInsulationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__